export interface U2103LoadRolesHandlersParams<T = any> {
  doLoadRolesFn: () => Promise<any>;
  onSuccess?: (rows: T[]) => void;
  onError?: (errors: { error: any }) => void;
}

export interface U2103LoadRolesHandlersReturn {
  loadRoles: () => void;
}

export function useU2103LoadRolesHandlers<T extends { id: string } = any>({ doLoadRolesFn, onSuccess, onError }: U2103LoadRolesHandlersParams<T>): U2103LoadRolesHandlersReturn {
  const loadRoles = async () => {
    try {
      const response = await doLoadRolesFn();
      const rows: T[] = response.data.results as unknown as T[];

      if (onSuccess) {
        onSuccess(rows);
      }
    } catch (error) {
      if (onError) {
        onError({ error });
      }
    }
  };

  return { loadRoles };
}
